import React, { useContext, useEffect } from "react";
import { Container } from "reactstrap";
import Wrapper from "components/PublicWrapper";
import { AppContext } from "components/AppContext";
import { useHistory } from "react-router-dom";

const Homepage = () => {
  const history = useHistory();
  const { loggedIn } = useContext(AppContext);

  useEffect(() => {
    if (loggedIn) history.push("/app");
  }, [loggedIn, history]);

  return (
    <Wrapper>
      <Container className="pt-5" fluid />
    </Wrapper>
  );
};

export default Homepage;
